module.exports = __webpack_public_path__ + "static/media/video.ab4541cb.mp4";